import type { IconData } from '@stacksjs/iconify-core'

export const lv1x1: IconData = {
  "body": "<g fill-rule=\"evenodd\"><path fill=\"#fff\" d=\"M0 0h512v512H0z\"/><path fill=\"#981e32\" d=\"M0 0h512v204.8H0zm0 307.2h512V512H0z\"/></g>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default lv1x1
